import { render } from "./ChangePlanNew.vue?vue&type=template&id=2f420957"
import script from "./ChangePlanNew.vue?vue&type=script&lang=js"
export * from "./ChangePlanNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__